// Copyright (c) 2016 Deere & Company

import DateRange from '@deere/cps-it.warranty-model-factory/lib/date-range';
import moment from 'moment';

export const getDefaultState = () =>
    new DateRange({
        max: moment
            .utc()
            .add(10, 'year')
            .endOf('day')
            .valueOf(),
        min: moment
            .utc()
            .subtract(10, 'year')
            .startOf('day')
            .valueOf()
    });




// WEBPACK FOOTER //
// ./src/reports/claim-history/state/date-range.js